import { Alert } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const noConnectedPlatformsMessage = defineMessage({
  id: 'fragments.socialExport.panorama.noConnectedPlatforms',
  defaultMessage: 'No hay plataformas conectadas para publicar',
});

/**
 * Warning shown when the fragment could be published but the station has no connected social platforms.
 */
export function SocialExportNoPlatformsAlert() {
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <FormattedMessage {...noConnectedPlatformsMessage} />
    </Alert>
  );
}
